(() => {
  if (customElements.get('slider-reviews')) {
    return;
  }

  class SliderReviews extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        enabled: true,
        slidesPerView: 1.25,
        centeredSlides: true,
        spaceBetween: 18,
        grabCursor: true,
        autoHeight: true,
        navigation: {
          prevEl: this.querySelector('[data-arrow-prev]'),
          nextEl: this.querySelector('[data-arrow-next]'),
        },
        breakpoints: {
          768: {
            enabled: false,
            spaceBetween: 0,
          },
        },
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define('slider-reviews', SliderReviews);
})();
